import strings from 'owa-strings/owa-mail-strings';
export function getOpenInNewTabContextMenuItem(url, onClickCallback) {
    return {
        name: strings.OpenInNewTabText,
        key: 'OpenInNewTab',
        onClick: function () {
            window.open(url, '_blank');
            onClickCallback;
        },
    };
}
//# sourceMappingURL=getOpenInNewTabContextMenuItem.js.map